import home from './home'
import post from './post'
import message from './message'
import wallet from './wallet'
import earnMoney from './earnMoney'
import subscription from './subscription'
import withdraw from './withdraw'

export const decentralfansService = {
  home,
  post,
  message,
  wallet,
  earnMoney,
  subscription,
  withdraw,
}
